import React from "react"
import { useTranslation } from "react-i18next";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import ComunidadDocs from "../../../components/Comunidad/ComunidadDocs";


const Ventas = () => {
    const { t } = useTranslation('common');
//   const [pdfUrl, setPdfUrl] = useState('');

//   const convertirAPdf = async () => {
//     try {
//       const response = await generarPDF();
//       const url = URL.createObjectURL(response.data);
//       setPdfUrl(url);
//       // Abre el PDF en una nueva ventana o pestaña
//       const newWindow = window.open(url, '_blank');
//       if (newWindow) {
//         newWindow.focus();
//       } else {
//         alert('La ventana emergente está bloqueada. Habilita las ventanas emergentes en tu navegador para ver el PDF.');
//       }
//     } catch (error) {
//       console.error('Error al generar el PDF:', error);
//     }
//   };

//   return (
//     <div>
//       <button onClick={convertirAPdf}>Generar PDF</button>
//       {pdfUrl && <embed src={pdfUrl} width="100%" height="500" type="application/pdf" />}
//     </div>
//   );
    return (
        <>
            <BreadCrumb rutas={[{path:'/servicios', label: t('services.title')}]} style={{ margin: '0 10px'}} />
            <div className="listPage">
                <div className="gridCard">
                    <div className="gridHead">
                        {t('services.title').toUpperCase()}
                    </div>
                </div>
            </div>
            <ComunidadDocs />
        </>
     );
}
 
export default Ventas;